import { render, staticRenderFns } from "./SubmitConfirm.vue?vue&type=template&id=69e6ef1d&scoped=true&"
import script from "./SubmitConfirm.vue?vue&type=script&lang=js&"
export * from "./SubmitConfirm.vue?vue&type=script&lang=js&"
import style0 from "./SubmitConfirm.vue?vue&type=style&index=0&id=69e6ef1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e6ef1d",
  null
  
)

export default component.exports